import { Checkbox } from "antd";
import { useState } from "react";
import { useUserStore } from "../../stores/userStore";

export const BRAND_CONTRACT_TERMS = {
  title: "brand_campaign_terms",
  version: "1.0",
  items: [
    "캠페인 운영, 콘텐츠 활용 및 저작권, 성과 데이터 활용, 개인정보 수집 및 이용에 관한 필수 약관에 동의합니다.",
    "결제 지연·미이행 또는 캠페인 일정 미준수로 발생하는 패널티 규정을 확인하고 동의합니다.",
    "동일 주문서 내 크리에이터 중 1인 이상에 대한 정산이 개시되거나 완료된 경우, 해당 주문 전체에 대한 취소 및 환불이 제한될 수 있음에 동의합니다.",
  ],
  terms_url:
    "https://d1gjeqjbl7179w.cloudfront.net/terms/brand_campaign_terms_v1.html",
  required: true,
};

export const CREATOR_CONTRACT_TERMS = {
  title: "creator_campaign_terms",
  version: "1.0",
  items: [
    "캠페인 참여, 콘텐츠 이행 및 활용, 성과 데이터 제공, 보상 조건 및 책임, 개인정보 수집·이용에 관한 필수 약관에 동의합니다.",
    "캠페인 계약 불이행 또는 단순 변심에 따른 패널티 규정을 확인하고 동의합니다.",
  ],
  penalty_items: [
    "캠페인 참여 확정 후 콘텐츠를 제작 또는 게시하지 않는 경우",
    "합의된 게시 일정을 준수하지 않는 경우",
    "단순 변심으로 캠페인을 취소하는 경우",
  ],
  terms_url:
    "https://d1gjeqjbl7179w.cloudfront.net/terms/creator_campaign_terms_v1.html",
  required: true,
};

export const Contract = ({ onChange }) => {
  const { userInfo } = useUserStore();
  const [checkedItems, setCheckedItems] = useState({});

  const isBrand = userInfo?.user_info?.user_type === "brand";

  const contractTerms = isBrand ? BRAND_CONTRACT_TERMS : CREATOR_CONTRACT_TERMS;

  const toggle = (idx) => {
    setCheckedItems((prev) => {
      const next = { ...prev, [idx]: !prev[idx] };

      const allAgreed = contractTerms.items.every((_, i) => next[i]);

      onChange?.({ agreements: next, agreed: allAgreed });
      return next;
    });
  };

  return (
    <div className="flex flex-col gap-2">
      {contractTerms.items.map((text, idx) => (
        <div key={idx}>
          <label className="flex items-center gap-2 cursor-pointer">
            <Checkbox
              checked={checkedItems[idx] || false}
              onChange={() => toggle(idx)}
            />
            <div className="flex-1">
              <div className="flex items-center gap-1">
                <p className="text-[14px] leading-snug break-words">
                  {contractTerms.required && (
                    <span className="shrink-0 whitespace-nowrap text-[#ff4d4f] font-light text-[12px] mr-2">
                      (필수)
                    </span>
                  )}
                  {text}
                </p>
              </div>
            </div>
          </label>

          {idx === 1 &&
            contractTerms.penalty_items &&
            contractTerms.penalty_items.length > 0 && (
              <div className="ml-[26px] my-4 p-3 rounded-lg border border-[#e0e0e0]">
                <div className="flex flex-col gap-1.5">
                  {contractTerms.penalty_items.map(
                    (penaltyItem, penaltyIdx) => (
                      <div
                        key={penaltyIdx}
                        className="text-[12px] text-[#171717] leading-relaxed"
                      >
                        • {penaltyItem}
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
        </div>
      ))}
    </div>
  );
};
